import React from 'react';
import styles from './titleActionsMenu.module.scss';

interface Props {
  children: string;
}
const TitleActionsMenu: React.FC<Props> = ({ children = 'Acciones' }) => <h3 className={styles.title}>{children}</h3>;

export default TitleActionsMenu;
